/**
 * Do not edit directly
 * Generated on Tue, 14 Jul 2026 09:54:51 GMT
 */

export const xs = "4px";
export const sm = "8px";
export const md = "16px";
export const lg = "32px";
export const xl = "64px";
